export default (item) => ({
  content: {
    delta: item?.content_delta,
  },
  title: item?.title,
  altText: item?.alt_text,
})
